<template>
  <base-entity-card
    :id="id"
    titleName="услуги"
    :saveFunc="save"
    :loading="loading"
    @closed="restoreEntity"
    :oneColumn="false"
  >
    <v-form ref="form" v-model="isValid">
      <v-alert
        type="error"
        v-if="Boolean(error)"
      >{{ error }}</v-alert>
      <v-card>
        <v-card-title>00. Копирование страницы</v-card-title>
        <v-card-text>
          <v-autocomplete
            label="Выберите страницу"
            v-model="originalPageId"
            :items="pages"
            filled
            clearable
          ></v-autocomplete>
          <div class="d-flex">
            <v-spacer></v-spacer>
            <v-btn 
              color="primary" 
              dark 
              @click="copyPage()"
            > 
              <v-icon left>mdi-content-copy</v-icon>
              Скопировать данные
            </v-btn>
            <v-spacer></v-spacer>
          </div>
        </v-card-text>
      </v-card>

      <v-card class="mt-7"> <!-- Блок "Основная информация" -->
        <v-card-title>01. Основные настройки</v-card-title>
        <v-card-text>
         
          <v-text-field
            label="Название услуги *"
            v-model="entity.name"
            :rules="[v => !!v || 'Введите название услуги.']"
            filled
          ></v-text-field>
         
          <v-text-field
            label="Тэг *"
            v-model="entity.tag"
            filled
            append-icon="mdi-autorenew"
            @click:append="generateTag()"
          ></v-text-field>
          <v-text-field
            label="Название пункта меню *"
            v-model="entity.menuName"
            :rules="[v => !!v || 'Введите название пункта меню.']"
            filled
          ></v-text-field>
          <v-text-field
            label="Имя объекта"
            v-model="entity.objectName"
            filled
          ></v-text-field>
          <v-text-field
            label="Имя объекта (чего?)"
            v-model="entity.objectNameWhom"
            filled
          ></v-text-field>
          <v-switch
            v-model="entity.isFirstLevel"
            :label="`Услуга первого уровня: ${entity.isFirstLevel ? 'да' : 'нет'}`"
          ></v-switch>
          <template v-if="!entity.isFirstLevel">
            <v-autocomplete
              label="Тэг родителя *"
              v-model="entity.parentTag"
              :items="pagesTagsData"
              filled
              :rules="[v => !!v || 'Введите тэг родителя.']"
            ></v-autocomplete>
          </template>
        </v-card-text>
      </v-card>
      
      <v-card class="mt-7">  <!-- Блок "Первый экран" -->
        <v-card-title>02. Первый экран</v-card-title>
        <v-card-text>
          <v-text-field
            label="Заголовок H1 *"
            v-model="entity.topLayout.h1Text"
            :rules="[v => !!v || 'Введите заголовок h1.']"
            filled
          ></v-text-field>
          <v-text-field
            label="Текст ссылки на калькулятор *"
            v-model="entity.topLayout.calcButtonText"
            :rules="[v => !!v || 'Укажите текст ссылки.']"
            filled
          ></v-text-field>
          <text-chips
            v-model="entity.topLayout.advantages"
            label="Ключевые преимущества"
          ></text-chips>
        </v-card-text>
      </v-card>
      
      <v-card class="mt-7"> <!-- Блок "Преимущества" -->
        <v-card-title>03. Преимущества</v-card-title>
        <v-card-text>
          <v-switch
            v-model="entity.advantageLayout.isInhereted"
            :label="`Наследование от родителя: ${entity.advantageLayout.isInhereted ? 'включено': 'выключено'}`"
            :disabled="entity.isFirstLevel"
          ></v-switch>
          <template v-if="!entity.advantageLayout.isInhereted">
            <v-text-field
              v-model="entity.advantageLayout.h2Text"
              label="Заголовок H2 *"
              filled
              :rules="[v => !!v || 'Введите заголовок h2.']"
            ></v-text-field>
            <v-data-table
              :items="entity.advantageLayout.advantages"
              item-key="_id"
              :headers="advHeaders"
              hide-default-footer
              :key="'adv' + componentId"
            >
              <template v-slot:[`item.icon`]="{ item }">
                <img :src="'/icons/' + item.icon">
               
              </template>
              <template v-slot:[`item.actions`]="{ item }">
                <div style="display: flex; align-items: center;">
                  <div style="display: inline-block; width: 10px; margin-right:15px;">
                    <v-icon small @click="upAdvantage(item._id)">mdi-menu-up</v-icon>
                    <v-icon small @click="downAdvantage(item._id)">mdi-menu-down</v-icon>
                  </div>
                  <site-page-advantage-card 
                    @input="saveAdvantage($event)"
                    :value="item"
                    :key="item._id"
                  ></site-page-advantage-card>
                  <v-btn icon @click="deleteAdvantage(item._id)">
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </div>
              </template>
            </v-data-table>
            <div class="d-flex pt-2">
              <v-spacer></v-spacer>
              <site-page-advantage-card @input="saveAdvantage($event)"></site-page-advantage-card>
              <v-spacer></v-spacer>
            </div>
          </template>
        </v-card-text>
      </v-card>

      <v-card class="mt-7"> <!-- Блок "Сотрудники" -->
        <v-card-title>04. Сотрудники</v-card-title>
        <v-card-text>
          <v-switch
            v-model="entity.specialistLayout.isInhereted"
            :label="`Наследование от родителя: ${entity.specialistLayout.isInhereted ? 'включено': 'выключено'}`"
            :disabled="entity.isFirstLevel"
          ></v-switch>
          <template v-if="!entity.specialistLayout.isInhereted">
            <v-text-field
              v-model="entity.specialistLayout.h2Text"
              label="Заголовок H2 *"
              filled
              :rules="[v => !!v || 'Введите заголовок h2.']"
            ></v-text-field>
            <v-textarea
              v-model="entity.specialistLayout.description"
              label="Описание под заголовком"
              filled
            ></v-textarea>
            <v-text-field
              v-model="entity.specialistLayout.teamLinkText"
              label="Текст ссылки на страницу команды"
              filled
            ></v-text-field>
            <v-autocomplete
              label="Отображаемые сотрудники"
              v-model="entity.specialistLayout.specialists"
              multiple
              small-chips
              deletable-chips
              filled
              :items="specialists"
            ></v-autocomplete>
            <text-chips 
              :key="'team_adv' + componentId"
              v-model="entity.specialistLayout.advantages"
              label="Преимущества по сотрудникам"
            ></text-chips>
          </template>
        </v-card-text>
      </v-card>

      <v-card class="mt-7"> <!-- Блок "Готовые решения" -->
        <v-card-title>
          05. Готовые решения
          <v-spacer></v-spacer>
          <v-switch
            v-model="entity.solutionsLayout.isActive"
          ></v-switch>
        </v-card-title>
        <v-card-text v-if="entity.solutionsLayout.isActive">
          <v-switch
            v-model="entity.solutionsLayout.isInhereted"
            :label="`Наследование от родителя: ${entity.solutionsLayout.isInhereted ? 'включено': 'выключено'}`"
            :disabled="entity.isFirstLevel"
          ></v-switch>
          <template v-if="!entity.solutionsLayout.isInhereted">
            <v-text-field
              v-model="entity.solutionsLayout.h2Text"
              label="Заголовок H2 *"
              filled
              :rules="[v => !!v || 'Введите заголовок h2.']"
            ></v-text-field>
            <v-textarea
              v-model="entity.solutionsLayout.description"
              label="Описание под заголовком"
              filled
            ></v-textarea>
            <v-autocomplete
              label="Отображаемые решения"
              v-model="entity.solutionsLayout.solutions"
              multiple
              small-chips
              deletable-chips
              filled
              :items="solutions"
            ></v-autocomplete>
          </template>
        </v-card-text>
      </v-card>

      <v-card class="mt-7"> <!-- Блок "Калькулятор" -->
        <v-card-title>06. Калькулятор</v-card-title>
        <v-card-text>
          <v-switch
            v-model="entity.calcLayout.isInhereted"
            :label="`Наследование от родителя: ${entity.calcLayout.isInhereted ? 'включено': 'выключено'}`"
            :disabled="entity.isFirstLevel"
          ></v-switch>
          <template v-if="!entity.calcLayout.isInhereted"> 
            <v-text-field
              v-model="entity.calcLayout.h2Text"
              label="Заголовок H2 *"
              filled
              :rules="[v => !!v || 'Введите заголовок h2.']"
            ></v-text-field>
            <v-data-table
              :items="entity.calcLayout.fields"
              :headers="fldHeaders"
              hide-default-footer
            >
              <template v-slot:[`item.actions`]="{ item }">
                <div style="display: flex; align-items: center;">
                  <div style="display: inline-block; width: 10px; margin-right:15px;">
                    <v-icon small @click="upCalcField(item._id)">mdi-menu-up</v-icon>
                    <v-icon small @click="downCalcField(item._id)">mdi-menu-down</v-icon>
                  </div>
                  <site-page-calc-field-card 
                    @input="saveField($event)"
                    :value="item"
                    :key="item._id"
                  ></site-page-calc-field-card>
                  <v-btn icon @click="deleteField(item._id)">
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </div>
              </template>
            </v-data-table>
            <div class="d-flex pt-2">
              <v-spacer></v-spacer>
              <site-page-calc-field-card @input="saveField($event)"></site-page-calc-field-card>
              <v-spacer></v-spacer>
            </div>
          </template>
        </v-card-text>
      </v-card>

      <v-card class="mt-7"> <!-- Блок "Портфолио" -->
        <v-card-title>
          07. Портфолио
          <v-spacer></v-spacer>
          <v-switch
            v-model="entity.portfolioLayout.isActive"
          ></v-switch>
        </v-card-title>
        <v-card-text v-if="entity.portfolioLayout.isActive">
          <v-switch
            v-model="entity.portfolioLayout.isInhereted"
            :label="`Наследование от родителя: ${entity.portfolioLayout.isInhereted ? 'включено': 'выключено'}`"
            :disabled="entity.isFirstLevel"
          ></v-switch>
          <template v-if="!entity.portfolioLayout.isInhereted">
            <v-text-field
              v-model="entity.portfolioLayout.h2Text"
              label="Заголовок H2 *"
              filled
              :rules="[v => !!v || 'Введите заголовок h2.']"
            ></v-text-field>
            <v-textarea
              v-model="entity.portfolioLayout.description"
              label="Описание под заголовком"
              filled
            ></v-textarea>
            <v-autocomplete
              label="Отображаемые объекты"
              v-model="entity.portfolioLayout.portfolios"
              multiple
              small-chips
              deletable-chips
              filled
              :items="portfolios"
            ></v-autocomplete>
          </template>
        </v-card-text>
      </v-card>

      <v-card class="mt-7"> <!-- Блок "Репутация" -->
        <v-card-title>
          08. Репутация
          <v-spacer></v-spacer>
          <v-switch
            v-model="entity.reputationLayout.isActive"
          ></v-switch>
        </v-card-title>
        <v-card-text v-if="entity.reputationLayout.isActive">
          <v-switch
            v-model="entity.reputationLayout.isInhereted"
            :label="`Наследование от родителя: ${entity.reputationLayout.isInhereted ? 'включено': 'выключено'}`"
            :disabled="entity.isFirstLevel"
          ></v-switch>
          <template v-if="!entity.reputationLayout.isInhereted">
            <v-text-field
              v-model="entity.reputationLayout.h2Text"
              label="Заголовок H2 *"
              filled
              :rules="[v => !!v || 'Введите заголовок h2.']"
            ></v-text-field>
            <v-textarea
              v-model="entity.reputationLayout.description"
              label="Описание под заголовком"
              filled
            ></v-textarea>
            <v-autocomplete
              label="Отображаемые отзывы"
              v-model="entity.reputationLayout.testimonials"
              multiple
              small-chips
              deletable-chips
              filled
              :items="testimonials"
            ></v-autocomplete>
            <v-switch
              v-model="entity.reputationLayout.isActiveShowObject"
              :label="`Показывать запись на объект в работе: ${entity.reputationLayout.isActiveShowObject ? 'да': 'нет'}`"
              
            ></v-switch>
          </template>
        </v-card-text>
      </v-card>

      <v-card class="mt-7"> <!-- Блок "Вопрос-ответ" -->
        <v-card-title>
          09. Вопрос-ответ
          <v-spacer></v-spacer>
          <v-switch
            v-model="entity.faqLayout.isActive"
          ></v-switch>
        </v-card-title>
        <v-card-text v-if="entity.faqLayout.isActive">
          <v-switch
            v-model="entity.faqLayout.isInhereted"
            :label="`Наследование от родителя: ${entity.faqLayout.isInhereted ? 'включено': 'выключено'}`"
            :disabled="entity.isFirstLevel"
          ></v-switch>
          <template v-if="!entity.faqLayout.isInhereted">
            <v-text-field
              v-model="entity.faqLayout.h2Text"
              label="Заголовок H2 *"
              filled
              :rules="[v => !!v || 'Введите заголовок h2.']"
            ></v-text-field>
            <v-textarea
              v-model="entity.faqLayout.description"
              label="Описание под заголовком"
              filled
            ></v-textarea>
            <v-autocomplete
              label="Отображаемые вопросы"
              v-model="entity.faqLayout.questions"
              multiple
              small-chips
              deletable-chips
              filled
              :items="questions"
            ></v-autocomplete>
            
          </template>
        </v-card-text>
      </v-card>

      <v-card class="mt-7"> <!-- Блок "Примеры смет" -->
        <v-card-title>
          10. Примеры смет
          <v-spacer></v-spacer>
          <v-switch
            v-model="entity.estimatesLayout.isActive"
          ></v-switch>
        </v-card-title>
        <v-card-text v-if="entity.estimatesLayout.isActive">
          <v-switch
            v-model="entity.estimatesLayout.isInhereted"
            :label="`Наследование от родителя: ${entity.estimatesLayout.isInhereted ? 'включено': 'выключено'}`"
            :disabled="entity.isFirstLevel"
          ></v-switch>
          <template v-if="!entity.estimatesLayout.isInhereted">
            <v-text-field
              v-model="entity.estimatesLayout.h2Text"
              label="Заголовок H2 *"
              filled
              :rules="[v => !!v || 'Введите заголовок h2.']"
            ></v-text-field>
            <v-textarea
              v-model="entity.estimatesLayout.description"
              label="Описание под заголовком"
              filled
            ></v-textarea>
            <v-autocomplete
              label="Отображаемые сметы"
              v-model="entity.estimatesLayout.estimates"
              multiple
              small-chips
              deletable-chips
              filled
              :items="estimates"
            ></v-autocomplete>
            
          </template>
        </v-card-text>
      </v-card>

      <v-card class="mt-7"> <!-- Блок "Дизайн-проект" -->
        <v-card-title>
          11. Пример дизайн-проекта
          <v-spacer></v-spacer>
          <v-switch
            v-model="entity.designLayout.isActive"
          ></v-switch>
        </v-card-title>
      </v-card>

      <v-card class="mt-7"> <!-- Блок "Бонус" -->
        <v-card-title>
          12. Бонус
          <v-spacer></v-spacer>
          <v-switch
            v-model="entity.bonusLayout.isActive"
          ></v-switch>
        </v-card-title>
        <v-card-text v-if="entity.bonusLayout.isActive">
          <v-switch
            v-model="entity.bonusLayout.isInhereted"
            :label="`Наследование от родителя: ${entity.bonusLayout.isInhereted ? 'включено': 'выключено'}`"
            :disabled="entity.isFirstLevel"
          ></v-switch>
          <template v-if="!entity.bonusLayout.isInhereted">
            <v-text-field
              v-model="entity.bonusLayout.h2Text"
              label="Заголовок H2 *"
              filled
              :rules="[v => !!v || 'Введите заголовок h2.']"
            ></v-text-field>
            <v-textarea
              v-model="entity.bonusLayout.description"
              label="Описание под заголовком"
              filled
            ></v-textarea>
            <v-data-table
              :items="entity.bonusLayout.bonuses"
              :headers="bonusHeaders"
              hide-default-footer
            >
              <template v-slot:[`item.actions`]="{ item }">
                <site-page-bonus-card 
                  @input="saveBonus($event)"
                  :value="item"
                  :key="item._id"
                ></site-page-bonus-card>
                <v-btn icon @click="deleteBonus(item._id)">
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </template>
            </v-data-table>
            <div class="d-flex pt-2">
              <v-spacer></v-spacer>
              <site-page-bonus-card @input="saveBonus($event)"></site-page-bonus-card>
              <v-spacer></v-spacer>
            </div>
          </template>
        </v-card-text>
      </v-card>

      <v-card class="mt-7"> <!-- Блок "SEO" -->
        <v-card-title>13. SEO-оптимизация</v-card-title>
        <v-card-text>
          <v-textarea
            v-model="entity.seoLayout.title"
            label="Title *"
            filled
            :rules="[v => !!v || 'Введите title страницы.']"
          ></v-textarea>
          <v-textarea
            v-model="entity.seoLayout.description"
            label="META: Description"
            filled
          ></v-textarea>
          <v-textarea
            v-model="entity.seoLayout.keywords"
            label="META: Keywords"
            filled
          ></v-textarea>
          <v-text-field
            v-model="entity.seoLayout.redirect1"
            label="Redirect #1"
            filled
          ></v-text-field>
          <v-text-field
            v-model="entity.seoLayout.redirect2"
            label="Redirect #1"
            filled
          ></v-text-field>
           <v-text-field
            v-model="entity.seoLayout.redirect3"
            label="Redirect #3"
            filled
          ></v-text-field>
          <v-switch
            v-model="entity.seoLayout.isActiveSeoText"
            :label="`Включен SEO-текст: ${entity.seoLayout.isActiveSeoText ? 'да': 'нет'}`"
          ></v-switch>
          <template v-if="entity.seoLayout.isActiveSeoText">
            <span class="subtitle-2">Шаблон SEO-текста</span>
            <v-md-editor class="mt-3 mb-5" v-model="entity.seoLayout.seoTextTemplate" height="400px"></v-md-editor>
            <v-switch
              v-model="entity.seoLayout.isActiveSeoTextCities"
              :label="`Включены SEO-тексты по городам: ${entity.seoLayout.isActiveSeoTextCities ? 'да': 'нет'}`"
            ></v-switch>
            <template v-if="entity.seoLayout.isActiveSeoTextCities">
               <v-text-field
                label="Тексты по городам"
                :value="Boolean(entity.seoLayout.seoTextCities) ? 'Данные загружены': 'Нет данных'"
                filled
                readonly
                @click="isActiveCitiesForm = true;"
              ></v-text-field>
              <site-page-text-cities
                v-model="entity.seoLayout.seoTextCities"
                :activeMode="isActiveCitiesForm"
                @closeForm="isActiveCitiesForm = false"
                :template="entity.seoLayout.seoTextTemplate"
              ></site-page-text-cities>
            </template>
           
          </template>
        </v-card-text>
      </v-card>

    </v-form>
  </base-entity-card>
</template>

<script>
const MongoID = require('mongoose').Types.ObjectId;
import SiteEntityMixin from '../../../models/SiteEntityMixin';
import { transliterate as tr, slugify } from 'transliteration';
import SitePageAdvantageCard from './SitePageAdvantageCard';
import SitePageCalcFieldCard from './SitePageCalcFieldCard';
import SitePageBonusCard from './SitePageBonusCard';
import SitePageTextCities from './SitePageTextCities';
import _ from 'lodash';

export default {
  name: 'site-page-card',

  mixins: [SiteEntityMixin],

  components: {
    SitePageAdvantageCard,
    SitePageCalcFieldCard,
    SitePageBonusCard,
    SitePageTextCities
  },

  data() {
    return {
      tag: 'page',
      error: '',
      componentId: this.getTempId(),
      isActiveCitiesForm: false,
      originalPageId: null,
      advHeaders: [
        {
          text: 'Иконка',
          value: 'icon'
        },
        {
          text: 'Заголовок',
          value: 'name'
        },
        {
          text: 'Действия',
          value: 'actions'
        }
      ],
      fldHeaders: [
        {
          text: 'Название поля',
          value: 'label'
        },
        {
          text: 'Действия',
          value: 'actions'
        }
      ],
      bonusHeaders: [
        {
          text: 'Заголовок',
          value: 'name'
        },
        {
          text: 'Действия',
          value: 'actions'
        }
      ],
    }
  },

  methods: {
    getDefaultEntity() {
      return {
        site: null,
        tag: '', // тэг - адрес страницы на сайте
        isFirstLevel: false, // страница 1-го уровня (не имеет предка)
        parentTag: '', // тэг - адрес родительской страницы
        name: '', // название услуги - например "Ремонт квартиры"
        menuName: '', // название пункта в главном меню - например "Квартира"
        objectName: '', // Название объекта: квартира (Блоки могут подменять свои данные на этот ключ)
        objectNameWhow: '', // Названия объекта (чего?): квартиры (Блоки могут подменять свои данные на этот ключ)
        topLayout: { // Первый экран
          h1Text: '', // Заголовок h1 страницы
          advantages: [], // 3 ключевых преимущества 
          calcButtonText: 'Калькулятор', // Название кнопки-ссылки на Калькулятор
        },
        advantageLayout: { // Блок преимуществ
          isInhereted: false, // Наследование от Родителя
          h2Text: '', // Заголовок блока
          advantages: [],
        },
        specialistLayout: { // Блок про сотрудников
          isInhereted: false, // Наследование от Родителя
          h2Text: '', // Заголовок блока
          description: '', // Описание - текст под заголовком
          specialists: [], // Каких специалистов мы выводим на этой странице (список _id)
          teamLinkText: '', // Текст ссылки на страницу Команда
          advantages: [], // Наши преимущества по Команде
        },
        solutionsLayout: { // Блок "Готовые решения"
          isInhereted: false, // Наследование от Родителя
          isActive: false, // Показывает есть ли данный блок на странице
          h2Text: '', // Заголовок блока
          description: '', // Описание - текст под заголовком
          solutions: []
        },
        calcLayout: { // Блок "Калькулятор"
          isInhereted: false, // Наследование от родителя
          h2Text: '', // Заголовок блока
          fields: []
        },
        portfolioLayout: { // Блок "Портфолио"
          isActive: false, // Есть ли этот блок на данной странице
          isInhereted: false, // Наследование от родителя
          h2Text: '', // Заголовок блока
          description: '', // Описание - текст под заголовком
          portfolios: []
        },
        reputationLayout: { // Блок "Репутация"
          isActive: false, // Есть ли этот блок на данной странице
          isInhereted: false, // Наследование от родителя
          h2Text: '', // Заголовок блока
          description: '', // Описание - текст под заголовком
          testimonials: [],
          isActiveShowObject: true, // Показывать блок "Запись на осмотр объекта в работе"
        },
        faqLayout: { // Блок "Часто-задаваемые вопросы"
          isActive: false, // Есть ли этот блок на данной странице
          isInhereted: false, // Наследование от родителя
          h2Text: '', // Заголовок блока
          description: '', // Описание - текст под заголовком
          questions:[],
        },
        estimatesLayout: { // Блок "Примеры смет"
          isActive: false, // Есть ли этот блок на данной странице
          isInhereted: false, // Наследование от родителя
          h2Text: '', // Заголовок блока
          description: '', // Описание - текст под заголовком
          estimates: []
        },
        designLayout: { // Блок "Пример дизайн-проекта"
          isActive: false, // Есть ли этот блок на данной странице
        },
        bonusLayout: { // Блок "Выберите бонус"
          isActive: false, // Есть ли этот блок на данной странице
          isInhereted: false, // Наследование от родителя
          h2Text: '', // Заголовок блока
          description: '', // Описание - текст под заголовком
          bonuses: []
        },
        seoLayout: { // Блок SEO-оптимизации страницы
          title: '', // Title страницы - например: Ремонт квартир [в-городе] без переплаты | цена от [мин-стоимость] руб за м2 | [Компания]
          description: '', // Description страницы
          keywords: '', // Keywords страницы
          redirect1: '',
          redirect2: '',
          redirect3: '',
          isActiveSeoText: false, // Используется ли SEO-текст для оптимизации страницы
          seoTextTemplate: '', // SEO-текст (Шаблон для генерации) - Описание технологии оказания услуги
          isActiveSeoTextCities: false,
          seoTextCities: null, // SEO-тексты - сгенерированы для каждого города (на основе шаблона)
        },
      }
    },
    generateTag() {
      this.entity.tag = slugify(this.entity.name);
    },
    copyPage() {
      if (!this.originalPageId) {
        this.$store.dispatch('showMessage', 'Страница-источник не выбрана');
        return;
      }
      let copy = _.cloneDeep(this.$store.state.sites.entities.page.find(x => x._id == this.originalPageId));
      //copy._id = this.entity._id;
      this.entity.advantageLayout = copy.advantageLayout;
      this.entity.specialistLayout = copy.specialistLayout;
      this.entity.solutionsLayout = copy.solutionsLayout;
      this.entity.calcLayout = copy.calcLayout;
      this.entity.faqLayout = copy.faqLayout;
      this.componentId = this.getTempId();
    },

    // Преимущества
    saveAdvantage(obj) {
      if (obj._id) {
        let index = this.entity.advantageLayout.advantages.findIndex(x => x._id == obj._id);
        this.entity.advantageLayout.advantages.splice(index, 1, obj);
      } else {
        obj._id = String(new MongoID());
        this.entity.advantageLayout.advantages.push(obj);
      }
    },
    deleteAdvantage(id) {
      let index = this.entity.advantageLayout.advantages.findIndex(x => x._id == id);
      this.entity.advantageLayout.advantages.splice(index, 1);
    },
    upAdvantage(id) {
      let index = this.entity.advantageLayout.advantages.findIndex(x => x._id == id);
      if (index > 0) {
        this.entity.advantageLayout.advantages.splice(index - 1, 2, 
          this.entity.advantageLayout.advantages[index],
          this.entity.advantageLayout.advantages[index - 1]
        );
      }
    },
    downAdvantage(id) {
      let index = this.entity.advantageLayout.advantages.findIndex(x => x._id == id);
      if (index < this.entity.advantageLayout.advantages.length - 1) {
        this.entity.advantageLayout.advantages.splice(index, 2, 
          this.entity.advantageLayout.advantages[index + 1],
          this.entity.advantageLayout.advantages[index]
        );
      }
    },

    // Поля калькулятора
    saveField(obj) {
      if (obj._id) {
        let index = this.entity.calcLayout.fields.findIndex(x => x._id == obj._id);
        this.entity.calcLayout.fields.splice(index, 1, obj);
      } else {
        obj._id = String(new MongoID());
        this.entity.calcLayout.fields.push(obj);
      }
    },
    deleteField(id) {
      let index = this.entity.calcLayout.fields.findIndex(x => x._id == id);
      this.entity.calcLayout.fields.splice(index, 1);
    },
    upCalcField(id) {
      let index = this.entity.calcLayout.fields.findIndex(x => x._id == id);
      if (index > 0) {
        this.entity.calcLayout.fields.splice(index - 1, 2, 
          this.entity.calcLayout.fields[index],
          this.entity.calcLayout.fields[index - 1]
        );
      }
    },
    downCalcField(id) {
      let index = this.entity.calcLayout.fields.findIndex(x => x._id == id);
      if (index < this.entity.calcLayout.fields.length - 1) {
        this.entity.calcLayout.fields.splice(index, 2, 
          this.entity.calcLayout.fields[index + 1],
          this.entity.calcLayout.fields[index]
        );
      }
    },

    // Бонусы
    saveBonus(obj) {
      if (obj._id) {
        let index = this.entity.bonusLayout.bonuses.findIndex(x => x._id == obj._id);
        this.entity.bonusLayout.bonuses.splice(index, 1, obj);
      } else {
        obj._id = String(new MongoID());
        this.entity.bonusLayout.bonuses.push(obj);
      }
    },
    deleteBonus(id) {
      let index = this.entity.bonusLayout.bonuses.findIndex(x => x._id == id);
      this.entity.bonusLayout.bonuses.splice(index, 1);
    },
  },
  watch: {
    ['entity.isFirstLevel'](newVal) {
      if (newVal) {
        ['advantageLayout', 'specialistLayout', 'calcLayout',
         'portfolioLayout', 'reputationLayout', 'faqLayout',
         'estimatesLayout', 'bonusLayout'].forEach(x => this.entity[x].isInhereted = false);
      }
    }
  },
  computed: {
    pagesTagsData() {
      return this.$store.state.sites.entities.page
        .filter(x => x._id != this.entity._id)
        .map(x => ({
          text: `${x.name} (${x.tag})`,
          value: x.tag
        }));
    },
    pages() {
      return this.$store.state.sites.entities.page
        .filter(x => x._id != this.entity._id)
        .map(x => ({
          text: `${x.name}`,
          value: x._id
        }));
    },
    specialists() {
      return this.$store.state.sites.entities.specialist.map(x => ({
        text: `${x.fullName} (${x.position})`,
        value: x._id
      }));
    },
    solutions() {
      return this.$store.state.sites.entities.solution.map(x => ({
        text: x.name,
        value: x._id
      }));
    },
    portfolios() {
      return this.$store.state.sites.entities.portfolio
        .filter(x => x.site == null)
        .map(x => ({
          text: x.name,
          value: x._id
        }));
    },
    testimonials() {
      return this.$store.state.sites.entities.testimonial
        .filter(x => x.site == null)
        .map(x => ({
          text: `${x.objectName} (${x.customerName})`,
          value: x._id
        }));
    },
    questions() {
      return this.$store.state.sites.entities.question
        .filter(x => x.site == null)
        .map(x => ({
          text: x.name,
          value: x._id
        }));
    },
    estimates() {
      return this.$store.state.estimates.estimates.map(x => ({
        text: x.name,
        value: x._id
      }));
    }
  }
}
</script>